var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransaksi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:notepad"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.25 10H16.25M8.25 14H16.25M8.25 18H12.25M8.25 4C8.25 5.10457 9.14543 6 10.25 6H14.25C15.3546 6 16.25 5.10457 16.25 4M8.25 4C8.25 2.89543 9.14543 2 10.25 2H14.25C15.3546 2 16.25 2.89543 16.25 4M8.25 4H7.25C5.04086 4 3.25 5.79086 3.25 8V18C3.25 20.2091 5.04086 22 7.25 22H17.25C19.4591 22 21.25 20.2091 21.25 18V8C21.25 5.79086 19.4591 4 17.25 4H16.25",
    stroke: "#E1DBDB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaksi);
export default __webpack_public_path__ + "static/media/transaksi.2a4b16ef4cb83704b3699e3711c11824.svg";
export { ForwardRef as ReactComponent };